export const environment = {
  production: true,
  prototype: false,
};
